import React, {FC, useEffect, useState} from 'react'
import {useAppDispatch} from 'src/redux/storeHooks'
import {getDashboardNewsAsync} from 'src/redux/actions/authActions'
import moment from 'moment'
import {DashboardNewsItem} from '../types/dashboard.types'
import Loader from 'src/utils/Loader'

const NewsUpdatesTab: FC = () => {
  const dispatch = useAppDispatch()
  const [news, setNews] = useState<DashboardNewsItem[]>([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [nextPageAvailable, setNextPageAvailable] = useState(false)
  const [totalCount, setTotalCount] = useState(0)

  useEffect(() => {
    setLoading(true)
    dispatch(getDashboardNewsAsync({page: currentPage, limit: 7}))
      .then((response) => {
        if (response.payload) {
          const rawNews = response.payload?.results || []
          const filteredNews = rawNews.filter(
            (item: DashboardNewsItem) => item.type?.trim().toUpperCase() !== 'COMING_SOON'
          )
          setNews(filteredNews)
          setTotalCount(response.payload?.count || 0)
        }
        setNextPageAvailable(Boolean(response.payload?.next))
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [currentPage, dispatch])

  return (
    <div className='dashboard-panel-card'>
      <div className='dashboard-panel-header'>
        <h3>Product Timeline</h3>
        {totalCount > 7 && (
          <div className='d-flex flex-column align-items-center gap-2 mt-1'>
            <div className='d-flex gap-2'>
              <button
                type='button'
                className='btn btn-primary rounded-pill shadow-sm'
                style={{transition: 'all 0.3s', fontSize: '11px', padding: '2px 10px'}}
                disabled={loading || currentPage <= 1}
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              >
                &larr; Prev
              </button>
              <button
                type='button'
                className='btn btn-primary rounded-pill shadow-sm'
                style={{transition: 'all 0.3s', fontSize: '11px', padding: '2px 10px'}}
                disabled={loading || !nextPageAvailable}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next &rarr;
              </button>
            </div>
            <div className='d-flex gap-1'>
              {Array.from({length: Math.ceil(totalCount / 7)}).map((_, i) => (
                <div
                  key={i}
                  style={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: currentPage === i + 1 ? '#0d6efd' : '#e9ecef',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s',
                  }}
                  onClick={() => setCurrentPage(i + 1)}
                />
              ))}
            </div>
          </div>
        )}
      </div>
      <div className='dashboard-panel-body'>
        {loading ? (
          <div className='d-flex justify-content-center py-10'>
            <Loader variant="section" />
          </div>
        ) : news.length > 0 ? (
          <div className='dashboard-timeline'>
            {news.map((item) => (
              <div key={item.id} className='dashboard-timeline-entry'>
                <div className='dashboard-timeline-dot' />
                <span className='dashboard-timeline-date'>
                  {moment(item.feature_released_date || item.created_at).format('DD MMMM YYYY')}
                </span>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className='dashboard-empty'>No news or updates posted yet.</div>
        )}
      </div>
    </div>
  )
}

export default NewsUpdatesTab
